import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { name: 'Home',       path: '/' },
  { name: 'About Me',   path: '/about' },
  { name: 'Skill',      path: '/skills' },
  { name: 'Background', path: '/resume' },
  { name: 'Projects',   path: '/projects' },
  { name: 'Contact',    path: '/contact' },
];

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className={`header${scrolled ? ' scrolled' : ''}`}>
        <div className="header__inner">
          <Link to="/" className="header__logo" onClick={closeMenu}>Haadi.</Link>
          <nav className="header__nav">
            <ol>
              {navLinks.map((link) => (
                <li key={link.name}><Link to={link.path}>{link.name}</Link></li>
              ))}
            </ol>
            <a href="/HaadiYakubu_DataAnalyst_Resume.pdf" target="_blank" rel="noopener noreferrer" className="header__resume-btn">
              Resume
            </a>
          </nav>
          <button className={`header__hamburger${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <span></span><span></span><span></span>
          </button>
        </div>
      </header>

      <nav className={`header__mobile-nav${menuOpen ? ' open' : ''}`}>
        <ol>
          {navLinks.map((link) => (
            <li key={link.name}><Link to={link.path} onClick={closeMenu}>{link.name}</Link></li>
          ))}
        </ol>
        <a href="/HaadiYakubu_DataAnalyst_Resume.pdf" target="_blank" rel="noopener noreferrer" className="mobile-resume-btn" onClick={closeMenu}>
          Resume
        </a>
      </nav>
      <div className={`nav-overlay${menuOpen ? ' open' : ''}`} onClick={closeMenu}></div>
    </>
  );
}

export default Header;